import { render, staticRenderFns } from "./BreakageCreate.vue?vue&type=template&id=154a34d2&scoped=true&"
import script from "./BreakageCreate.vue?vue&type=script&lang=js&"
export * from "./BreakageCreate.vue?vue&type=script&lang=js&"
import style0 from "./BreakageCreate.vue?vue&type=style&index=0&id=154a34d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a34d2",
  null
  
)

export default component.exports